(function($) {

  window.addEventListener("klaviyoForms", function(e) { 
    if (e.detail.type == 'submit') {
      ga('send', 'event', 'marketing', 'newsletter signup', e.detail.metaData.$source.toLowerCase() + ' submitted');
    }
  });

})(jQuery);